import { EditableGraphicsWidget } from "./editable-graphics.js";

export class EditableInlineGraphicsWidget extends EditableGraphicsWidget {
    updateElementData(element) {
        element.dataset.filepath = this.filePath || "";
        element.dataset.width = this.figureData?.width?.toString() || "";
        if (this.figureData?.width) {
            element.style.width = `min(100%, ${this.figureData.width * 100}%)`;
        } else {
            element.style.width = "";
        }
    }

    toDOM(view) {
        this.destroyed = false;

        const element = document.createElement("span");
        element.classList.add("ol-cm-graphics-inline-edit-wrapper");
        this.updateElementData(element);

        const inlineElement = document.createElement("span");
        inlineElement.classList.add("ol-cm-graphics-inline");
        this.renderGraphic(inlineElement, view);
        element.append(inlineElement);
        return element;
    }

    updateDOM(element, view) {
        const updated = super.updateDOM(element, view);
        if (!updated) {
            return false;
        }

        this.updateElementData(element);
        view.requestMeasure();
        return true;
    }

    ignoreEvent(event) {
        return event.type !== "mousedown" && event.type !== "mouseup";
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }

    getFigureWidth() {
        return "100%";
    }
}
